import React, { Fragment } from "react";
import Heading01 from "./Heading01/Heading01";

const Shared02Headings = ({ options }) => {
  //Des
  const { heading_version } = options;

  const headings = {
    heading_01: <Heading01 options={options} />,
  };

  const actual_heading = headings[heading_version] || false;

  return <Fragment>{actual_heading}</Fragment>;
};

export default Shared02Headings;
